import React from "react";
import { useSelector } from "react-redux";
import { Skeleton, Tooltip } from "antd";
import {
  getPaneIndex,
  getWindowLocationPath,
  kFormatter,
} from "../../../../redux/constants";

const SentimentCard = (props) => {
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const panes = useSelector((state) => state.Tab1.panes); //all tabs data
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const screen = useSelector((state) => state?.Screens?.screen);
  let index = getPaneIndex(panes, activeKey);
  let pathName = getWindowLocationPath()?.toLowerCase();

  const infoBarData =
    pathName === "CommandCenter"?.toLowerCase()
      ? screen?.deep_dive?.infoBar?.result?.info_bar
      : shareTemplateData
      ? shareTemplateData?.deep_dive?.infoBar?.result?.info_bar
      : panes[index]?.deep_dive?.infoBar?.result?.info_bar;
  let idsList = [1, 4];
  let data_map = [];
  infoBarData &&
    idsList?.forEach((e) => {
      data_map.push(
        infoBarData.filter((e1) => {
          return Number(e1.id) === e;
        })[0]
      );
    });
  return (
    <div className="deepDive__info bg__white border border-radius-4 mb-xs-3 mb-sm-3 d-sm-flex d-md-flex align-items-center justify-content-between">
      <div className="deepDive__info-list pl-15 pr-15 mt-15 mb-15 border-right">
        <span
          className={`portlet__title fontSize-14 font-weight500 mb-1 d-flex align-items-center " ${
            data_map.length === 0 ? "d-none" : ""
          }`}
        >
          {data_map && data_map[0]?.title}
          {data_map?.length &&
            data_map?.[0]?.id == "1" &&
            data_map?.[0]?.info_text && (
              <Tooltip
                title={data_map?.[0]?.info_text || ""}
                placement="top"
                className="text-ellipsis d-inline-block wm-chart-card-title"
              >
                <i className="fa fa-info-circle text-gray cursor-pointer ml-1" />
              </Tooltip>
            )}
        </span>
        <div
          className={`portlet__content fontSize-21 font-weight600 line-height-normal${
            data_map.length === 0 ? "d-none" : ""
          }`}
        >
          <Tooltip title={data_map ? data_map[0]?.count?.toLocaleString() : ""}>
            <span className="font-size24 mb-0 deepdive__span">
              {data_map && kFormatter(data_map[0]?.count)}
            </span>
          </Tooltip>
        </div>
        <div className={data_map.length >= 1 ? "d-none" : ""}>
          <Skeleton active size="small" paragraph={{ rows: 1 }} />
        </div>
      </div>
      <div className="deepDive__info-list pl-15 pr-15 mt-15 mb-15 border-right">
        <div className={data_map.length === 0 ? "d-none" : "d-flex"}>
          <span
            className="dot mt-1 mr-1"
            style={{
              backgroundColor: data_map && data_map[1]?.color?.Positive,
            }}
          ></span>
          <span className="portlet__title fontSize-14 font-weight500">
            Positive
          </span>
        </div>
        <div
          className={`portlet__content fontSize-21 font-weight600 ${
            data_map.length === 0 ? "d-none" : ""
          }`}
        >
          <Tooltip
            title={
              data_map ? data_map[1]?.count?.Positive?.toLocaleString() : ""
            }
          >
            <span className="font-size24 mb-0 deepdive__span">
              {data_map && kFormatter(data_map[1]?.count?.Positive)}
            </span>
          </Tooltip>

          <span className="mb-0 ml-1 deepdive__span fontSize-14">
            ({data_map && data_map[1]?.percentage?.Positive}%)
          </span>
        </div>
        <div className={data_map.length >= 1 ? "d-none" : ""}>
          <Skeleton active size="small" paragraph={{ rows: 1 }} />
        </div>
      </div>
      <div className="deepDive__info-list pl-15 pr-15 mt-15 mb-15 border-right">
        <div className={data_map.length === 0 ? "d-none" : "d-flex"}>
          <span
            className="dot mt-1 mr-1"
            style={{
              backgroundColor: data_map && data_map[1]?.color?.Negative,
            }}
          ></span>
          <span className="portlet__title fontSize-14 font-weight500">
            Negative
          </span>
        </div>
        <div
          className={`portlet__content fontSize-21 font-weight600 ${
            data_map.length === 0 ? "d-none" : ""
          }`}
        >
          <Tooltip
            title={
              data_map ? data_map[1]?.count?.Negative?.toLocaleString() : ""
            }
          >
            <span className="font-size24 mb-0 deepdive__span">
              {data_map && kFormatter(data_map[1]?.count?.Negative)}
            </span>
          </Tooltip>

          <span className="mb-0 ml-1 deepdive__span fontSize-14">
            ({data_map && data_map[1]?.percentage?.Negative}%)
          </span>
        </div>
        <div className={data_map.length >= 1 ? "d-none" : ""}>
          <Skeleton active size="small" paragraph={{ rows: 1 }} />
        </div>
      </div>
      <div className="deepDive__info-list pl-15 pr-15 mt-15 mb-15">
        <div className={data_map.length === 0 ? "d-none" : "d-flex"}>
          <span
            className="dot mt-1 mr-1"
            style={{ backgroundColor: data_map && data_map[1]?.color?.Neutral }}
          ></span>
          <span className="portlet__title fontSize-14 font-weight500">
            Neutral
          </span>
        </div>
        <div
          className={`portlet__content fontSize-21 font-weight600 ${
            data_map.length === 0 ? "d-none" : ""
          }`}
        >
          <Tooltip
            title={
              data_map ? data_map[1]?.count?.Neutral?.toLocaleString() : ""
            }
          >
            <span className="font-size24 mb-0 deepdive__span">
              {data_map && kFormatter(data_map[1]?.count?.Neutral)}
            </span>
          </Tooltip>

          <span className="mb-0 ml-1 deepdive__span fontSize-14">
            ({data_map && data_map[1]?.percentage?.Neutral}%)
          </span>
        </div>
        <div className={data_map.length >= 1 ? "d-none" : ""}>
          <Skeleton active size="small" paragraph={{ rows: 1 }} />
        </div>
      </div>
    </div>
  );
};

export default SentimentCard;
